module.exports = __webpack_public_path__ + "static/q4_o-2e3f8e449fe57f6b6d32b8efe9424538.png";